export default __webpack_public_path__ + "static/SRUS HPH400 - Especification Del Producto y Datos Técnicos-26b1d3b284f145e021b1e1432dc0a28c.pdf";